import { useAtom } from "../app-jotai";

import { authClient } from "./authClient";
import { AuthDialog } from "./AuthPanel";
import { ProfileDialog } from "./ProfileDialog";
import { accountDialogOpenAtom } from "./accountState";

import "./ProfileDialog.scss";

export const AccountControl = () => {
  const session = authClient.useSession();
  const [, setOpen] = useAtom(accountDialogOpenAtom);
  return (
    <button
      type="button"
      className="account-control"
      aria-label={
        session.data?.user ? "Open profile and integration keys" : "Sign in"
      }
      disabled={session.isPending}
      onClick={() => setOpen(true)}
    >
      {session.data?.user ? (
        <>
          <span className="account-control__avatar" aria-hidden="true">
            {session.data.user.name.trim().slice(0, 1).toUpperCase() || "A"}
          </span>
          <span>Account</span>
        </>
      ) : (
        "Sign in"
      )}
    </button>
  );
};

export const AccountDialogs = () => {
  const session = authClient.useSession();
  const [open, setOpen] = useAtom(accountDialogOpenAtom);
  if (!open) {
    return null;
  }
  return session.data?.user ? (
    <ProfileDialog
      key={session.data.user.id}
      user={session.data.user}
      onClose={() => setOpen(false)}
    />
  ) : (
    <AuthDialog onClose={() => setOpen(false)} />
  );
};
